import { Component, OnInit , ViewChild, ElementRef } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { RastreoService } from 'src/app/servicios/rastreo.service';
import Swal from 'sweetalert2';
import { user } from "../../entidades/gwuser";
import jwt_decode from "jwt-decode";
import { Router } from "@angular/router";
interface Colonia { idcol: number; asenta: string; }
import { from, forkJoin } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { AnalyticsService } from 'src/app/servicios/analytics.service';
import { mergeMap } from 'rxjs/operators';


@Component({
  selector: 'app-rastreo-envios',
  templateUrl: './rastreo-envios.component.html',
  styleUrls: ['./rastreo-envios.component.css']
})

export class RastreoEnviosComponent implements OnInit  {
  userGw: user;
  token: string;
  idcliente: number;
  isLoguedin: boolean;

  medioSeleccionado: string | null = null;

  mostrarRightContainer = false;

  telefono_mail: string = '';
  codigo: string[] = ['', '', '', ''];
  mostrarCodigo: boolean = false;

  // propiedades evidencia entrega
  entregaActual: any = null;
  firmaUrl: SafeUrl | string = 'assets/iconos/firma_example.png';
  fechaEntregaLegible = '';
  mostrarEvidencia: boolean = false;

  rastreoExpandido: any = null;
  mapaUrl: SafeResourceUrl | null = null;
  ultimaUbicacion: string | null = null;

  destinos: any[] = [];
  destinoSeleccionado: any = null;
  guardandoPredeterminado = false;

  enBusqueda = new Set<string>();

  formDestino: FormGroup;
  mensajeExito = false;
  formAsistencia: FormGroup;
  mensajeAsistenciaExito = false;

  valorMedio: string = '';
  mensajeConfirmacion: string = '';

  temasIncidencia: Array<{ idtema: number; tema: string }> = [];
  temaSeleccionado: string | null = null;
  mensajeTexto: string = '';
 imagePreviews: { url: SafeUrl, file?: File }[] = [];
  maxImages: number = 4;

  mensajeIncidenciaExito = false;
  mensajeIncidenciaError = false;
  animandoEntrada = false;
  animandoSalida = false;

  rastreoList: any[] = [];

  isCollapsed = true;
  collapsedStates: boolean[] = [];

  codigoBusqueda: string = '';
  codigosFiltrados: string[] = [];
  rastreoFiltradoList = this.rastreoList;

  incidencia: number = 0;

  currentDate = new Date();
  weeks: Date[][] = [];
  selectedDate: Date | null = null;

  temas: any[] = [];

  public colonias: Colonia[] = [];
  cargandoDestinos = false;
  enviandoIncidencia = false;
  incidenciaDetalle: any = null;

  chatMensaje = '';
  mensajesIncidencia: any[] = [];
  enviandoMsg = false;

  // Programar entrega
  motivos: Array<{ idtema: number; tema: string }> = [];
  motivoSeleccionado: number | null = null;
  rangosHorarios: Array<{ idtema: number; tema: string }> = [];
  rangoSeleccionado: number | null = null;
  temasMotivos: Array<{ idtema: number; tema: string }> = [];
  instruccionesEntrega: string = '';

  programacion: { rastreo?: string | number; motivo?: string; instrucciones?: string; rango?: string; fecha?: string } | null = null;
  programacionFechaLegible = '';


  notifs: any[] = [];               // lista de notificaciones actuales
  cargandoConfigNotif = false;      // loader
  eliminandoNotifId: number | null = null;  // id que se está eliminando

  // flag para item en proceso de eliminación
  eliminandoId: number | null = null;

  //reclamacion
showreclamo = false;
registrarIncidenciaActivo = false;
reclamacionForm: FormGroup;
enviandorec = false;
selectedFiles: Record<string, File | null> = {};
existingFiles: Record<string, boolean> = {};
fileRequired = (key: string) => (control: import('@angular/forms').AbstractControl) => {
  if (this.existingFiles[key]) return null;            // ya existe en backend
  if (this.selectedFiles[key]) return null;            // elegido en UI
  return { required: true };
};

fields = [
  { key: 'solicitud',       label: 'Solicitud reclamación' },
  { key: 'remision_envio',  label: 'Remisión envío' },
  { key: 'folio_seguro',    label: 'Folio de seguro' },
  { key: 'ine',             label: 'INE' },
  { key: 'factura',         label: 'Factura' },
];

// accept = '.pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx';
 accept = '.pdf';
fileNames: Record<string, string> = {};   // { key: nombreArchivo }

  private tipoToKey: Record<string, string> = {
    CRT: 'solicitud',
    REM: 'remision_envio',
    SEG: 'folio_seguro',
    INE: 'ine',
    FAC: 'factura',
  };

public domicilios: Array<{
  idedo: number;
  idcd: number;
  idcol: number;
  estado: string;
  ciudad: string;
  asenta: string;
}> = [];

public estados: string[] = [];
public ciudades: string[] = [];
// public colonias: string[] = [];

// Permisos del envío activo
permisosEnvio: {
  CambiarDireccion?: number;
  CambiarHorario?: number;
  PermitirAsistencias?: number;
  PermitirIncidencias?: number;
  Facturado?: number;     
  Canje?: string;         
  codigoCanje?: string;   //  alias opcional para plantilla
  urlpdf?: string;   
  urlxml?: string;
  owner?: 'SI' | 'NO' | string;
} | null = null;

  constructor(private sanitizer: DomSanitizer, private fb: FormBuilder,  private rastreoService: RastreoService, private router: Router, private analytics: AnalyticsService) { 
    this.formDestino = this.fb.group({
      estado: [{ value: null, disabled: true }, Validators.required],
      ciudad: [{ value: null, disabled: true }, Validators.required],
      colonia: [{ value: null, disabled: false }, Validators.required], // number | null
      nombre: ['', Validators.required],
      correo: ['', [Validators.required, Validators.email]],
      telefono: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      direccion: ['', Validators.required],
      referencia: ['']
    });

    this.formAsistencia = this.fb.group({
      nombre: ['', Validators.required],
      correo: ['', [Validators.required, Validators.email]],
      telefono: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
      tema: [null, Validators.required],
      mensaje: ['', Validators.required],
    });

    this.reclamacionForm = this.fb.group({
      nombrerec: ['', Validators.required],
      rfcrec: ['', Validators.required],
      telrec: ['', [Validators.required]],
      correorec: ['', [Validators.required, Validators.email]],
      identrec: ['', Validators.required],
      telcontactorec: ['', Validators.required],
      correocontactorec: ['', [Validators.required, Validators.email]],
      // Sub-form para archivos
    files: this.fb.group({})   // lo llenamos abajo
    });
      // Crea un control requerido por cada field
    const filesFG = this.reclamacionForm.get('files') as FormGroup;
    this.fields.forEach(f => {
      filesFG.addControl(f.key, new FormControl(null, [this.fileRequired(f.key)]));
    });
  }

    
  

ngOnInit(): void {
   this.generateCalendar(this.currentDate);
  // Inicializa variables
  this.codigoBusqueda = '';

  // Carga datos guardados en localStorage
  this.cargarFiltradosDesdeLocalStorage();

  // Si no hay datos en localStorage, inicializa vacíos
  if (!this.rastreoFiltradoList || this.rastreoFiltradoList.length === 0) {
    this.rastreoFiltradoList = [];
    this.codigosFiltrados = [];
  }

  // Inicializa collapsedStates acorde al tamaño de la lista filtrada
  this.collapsedStates = this.rastreoFiltradoList.map(() => true);

  // Limpia filtros si tienes esa función definida
  this.limpiarFiltros();

  this.actualizarOpcionesVisibles();
  window.addEventListener('resize', this.actualizarTamanoPantalla);

  this.cargarTemasAsist();
  this.cargarTemasIncidencia();

  // 👇 inicializa idcliente desde token y luego carga destinos
  this.initIdClienteFromToken();
}

  ngOnDestroy() {
  window.removeEventListener('resize', this.actualizarTamanoPantalla);
}

  // ngAfterViewInit() {
  //   this.scrollToBottom();
  // }

  // private scrollToBottom() {
  //   const el = this.chatContainer.nativeElement;
  //   el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
  // }


   opciones = [
    { nombre: 'Seguimiento', icono: 'fa-solid fa-map-location' },
    { nombre: 'Información', icono: 'fa-solid fa-circle-question' },
    { nombre: 'Cambiar domicilio', icono: 'fa-solid fa-location-crosshairs' },
    { nombre: 'Evidencia de entrega', icono: 'fas fa-signature' },
    { nombre: 'Notificaciones', icono: 'far fa-bell' },
    { nombre: 'Asistencia', icono: 'fa-solid fa-headset' },
    { nombre: 'Registrar incidencia', icono: 'fa-solid fa-triangle-exclamation' },
    { nombre: 'Programar entrega', icono: 'fas fa-clock' },
  ];


actualizarTamanoPantalla = () => {
  this.pantallaTablet = window.innerWidth < 1024 &&  window.innerWidth >= 720;
  this.actualizarOpcionesVisibles();
};

actualizarOpcionesVisibles() {
  let opcionesBase = [...this.opciones];

  // 1) Ocultar "Seguimiento" en no-tablet
  if (!this.pantallaTablet) {
    opcionesBase = opcionesBase.filter(op => op.nombre !== 'Seguimiento');
  }

  // 2) Si hay rastreo activo, aplica permisos
  if (this.rastreoExpandido) {
    // (A) Cambiar domicilio: combinar tu control previo (dispEntDm) con el permiso
    const disp = this.rastreoExpandido?.dispEntDm;
    const habilitaCambiarPorDisp = (disp === 0 || disp === '0' || disp === false);

    // Si existen permisos, los usamos; si no han llegado aún, asumimos 0 (ocultar)
    const p = this.permisosEnvio || {
      CambiarDireccion: 0,
      CambiarHorario: 0,
      PermitirAsistencias: 0,
      PermitirIncidencias: 0,
    };

    // 👉 Regla final por opción:
    const puedeCambiarDom = habilitaCambiarPorDisp && p.CambiarDireccion === 1;
    const puedeProgEntrega = p.CambiarHorario === 1;
    const puedeAsistencia = p.PermitirAsistencias === 1;
    const puedeIncidencia = p.PermitirIncidencias === 1;

    // Filtrado
    opcionesBase = opcionesBase.filter(op => {
      const name = op.nombre.trim();

      if (name === 'Cambiar domicilio') return puedeCambiarDom;
      if (name === 'Programar entrega') return puedeProgEntrega;
      if (name === 'Asistencia') return puedeAsistencia;
      if (name === 'Registrar incidencia') return puedeIncidencia;

      // las demás opciones siempre visibles
      return true;
    });

    // Si estabas parado en una opción que ya no está, redirige
    if (!opcionesBase.some(op => op.nombre === this.opcionSeleccionada)) {
      this.opcionSeleccionada =
        (opcionesBase.find(op => op.nombre === this.opcionDefault)?.nombre) ||
        (opcionesBase[0]?.nombre ?? '');
    }
  }

  this.opcionesVisibles = opcionesBase;

  // Asegura que la seleccionada exista
  if (!opcionesBase.some(op => op.nombre === this.opcionSeleccionada)) {
    this.opcionSeleccionada =
      (opcionesBase.find(op => op.nombre === this.opcionDefault)?.nombre) ||
      (opcionesBase[0]?.nombre ?? '');
  }
}

// opción preferida por defecto
private readonly opcionDefault = 'Información';

opcionesVisibles = [...this.opciones];
pantallaTablet = window.innerWidth <= 1024 && window.innerWidth >= 720;

// ⬇️ inicia en "Información"
opcionSeleccionada = this.opcionDefault;

seleccionarOpcion(opcion: string) {
  this.opcionSeleccionada = opcion;
   this.registrarIncidenciaActivo = (opcion === 'Registrar incidencia');

    // 📊 Evento GA4/GTM: opción seleccionada
  this.analytics.event('opcion_menu_click', {
    menu_opcion :  opcion // nombre visible de la opción
  });

  if (['Cambiar domicilio', 'Asistencia', 'Evidencia de entrega', 'Notificaciones', 'Registrar incidencia'].includes(opcion)) {
    this.validarLoginYMostrarDestino();
  }

  if (opcion === 'Registrar incidencia') {
   
  if (this.registrarIncidenciaActivo) {
    this.cargarIncidenciaParaRastreoActual();
  }
  
  }

  if (opcion === 'Programar entrega') {
    if (!this.motivos.length) { this.cargarTemasMotivos(); }
    if (!this.rangosHorarios.length) { this.cargarRangosHorarios(); }
    this.cargarProgramacionEntregaActual();
  }

  if (opcion === 'Notificaciones' && this.isLoguedin) {
    this.cargarConfigNotificaciones();
  }

  // 👇 Al entrar a “Evidencia de entrega”, rehidrata por si cambió el rastreo
  if (opcion === 'Evidencia de entrega') {
    this.hidratarEvidenciaDesdeRastreo();
  }
}


toggleCollapse(index: number) {
  // Toggle tipo acordeón
  this.collapsedStates = this.collapsedStates.map((_, i) => i === index ? !this.collapsedStates[i] : true);

  // Ahora SÍ sabemos si quedó abierta
  const nowExpanded = !this.collapsedStates[index];
  if (nowExpanded) {
    this.opcionSeleccionada = 'Información';
    this.registrarIncidenciaActivo = false;
  }

  const rastreo = this.rastreosFiltradosPorTexto()[index];
  this.rastreoExpandido = nowExpanded ? rastreo : null;

  if (rastreo) {
    this.analytics.event('rastreo_expandido', {
      codigo: rastreo.numrastreo,
      estatus: rastreo.estatus || '(sin estatus)',
      expanded: nowExpanded
    });
  }

  if (this.rastreoExpandido) {
    this.actualizarFormDesdeRastreo(this.rastreoExpandido);
    localStorage.setItem('rastreoExpandido', JSON.stringify(this.rastreoExpandido));

    this.mapaUrl = this.getMapaUrlParaRastreo(this.rastreoExpandido);
    this.hidratarEvidenciaDesdeRastreo();
    this.cargarPermisosEnvioActual();
    this.actualizarOpcionesVisibles();
    this.validaEsIncidencia();

    if (this.opcionSeleccionada === 'Registrar incidencia') {
      this.cargarIncidenciaParaRastreoActual();
    }
  } else {
    localStorage.removeItem('rastreoExpandido');
    this.ultimaUbicacion = null;
    this.mapaUrl = this.sanitizer.bypassSecurityTrustResourceUrl('about:blank');
    this.permisosEnvio = null;
    this.actualizarOpcionesVisibles();
  }
}



isPrimerIncompleto(timeline: any[], index: number): boolean {
  const paso = timeline[index];

  // Si el paso no está completado
  if (!paso.completado) {
    // Y si todos los pasos anteriores sí están completados
    const anterioresCompletados = timeline
      .slice(0, index)
      .every(p => p.completado);

    return anterioresCompletados;
  }

  return false;
}
filtrarPorCodigo() {
  
  const codigo = this.codigoBusqueda.trim();
 

  // Vacío
  if (!codigo) {
    this.analytics.event('busqueda_codigo_blocked', {
      reason: 'empty_code'
    });
    return;
  }

  //  ya está en curso
  if (this.enBusqueda.has(codigo)) return;

  //  ya existe en alguna de las listas
  if (this.codigosFiltrados.includes(codigo) ||
      this.rastreoFiltradoList.some(r => r.numrastreo === codigo)) {
    return;
  }

  if (this.codigosFiltrados.length >= 10) {
    alert('Solo puedes filtrar hasta 10 códigos de rastreo.');
    return;
  }

  // Marcar como en curso
  this.enBusqueda.add(codigo);

  this.rastreoService.track_pack2(codigo)
    .pipe(finalize(() => this.enBusqueda.delete(codigo)))
    .subscribe({
      next: (response: any[]) => {
        if (!response || response.length === 0) {
          alert('No se encontró información para ese código.');
          return;
        }

        const data = response[0];
        const ultPaso = [...data.historial].reverse().find(p => p.MensageCliente?.trim());

        const timeline = data.historial
          .filter(item => item.MensageCliente && item.MensageCliente.trim() !== '')
          .map((item: any) => {
            const fechaHora = item.fchlegible || `${item.fechamov} ${item.horamov}`;
            return {
              titulo: item.MensageCliente.trim(),
              ubicacion: item.UbicacionLegible || item.ubicacion,
              fechaHora,
              completado: true,
            };
          });

        const nuevoRastreo = {
          numrastreo: data.code,
          estatus: ultPaso?.MensageCliente || 'Sin información',
          origen: data.origen,
          destino: data.destino,
          timeline,
          entregaEstimada: data.fecha,
          remitente: data.remitente,
          destinatario: data.destinatario,
          cantidad: data.cant,
          tipoPaquete: data.envio,
          tipoEnvio: data.tipo,
          rastreoExt: data.rastreoExt,
          direccionActual: data.direccionActual,
          idedo: data.idedo,
          idcd: data.idcd,
          estado: data.Estado,
          ciudad: data.Ciudad,
          entrega: data.entrega,
          dispEntDm: data.dispEntDm,
          tipoServicio: data.TipoServicio,
           // (opcional) helper numérico para evitar strings vacíos
          entregaLat: data?.entrega?.lat ? Number(data.entrega.lat) : null,
          entregaLng: data?.entrega?.lng ? Number(data.entrega.lng) : null,
        };

        // Doble check antes de insertar (por si otra respuesta llegó primero)
        if (this.codigosFiltrados.includes(codigo) ||
            this.rastreoFiltradoList.some(r => r.numrastreo === nuevoRastreo.numrastreo)) {
          this.codigoBusqueda = '';
          return;
        }

        this.codigosFiltrados.push(codigo);
        this.rastreoFiltradoList.push(nuevoRastreo);
        this.collapsedStates = this.rastreoFiltradoList.map(() => true);
        this.codigoBusqueda = '';
        this.guardarFiltradosEnLocalStorage();

        this.rastreoExpandido = nuevoRastreo;
        this.actualizarFormDesdeRastreo(nuevoRastreo);
        this.actualizarOpcionesVisibles();
        this.cargarIncidenciaParaRastreoActual();
        this.cargarPermisosEnvioActual();

        const idedo = Number(nuevoRastreo.idedo);
        const idcd  = Number(nuevoRastreo.idcd);
        this.cargarDestinos(idedo, idcd);

        // --- Evento: éxito ---
        this.analytics.event('busqueda_rastreo', {
          codigo: nuevoRastreo.numrastreo,  // código del envío
          origen: nuevoRastreo.origen,
          destino: nuevoRastreo.destino
        });
      },
    // --- Evento: error ---
    error: () => {
      this.analytics.event('busqueda_rastreo', {
        status: 'error'
      });
      alert('Error al buscar el rastreo.');
    }
    });
}


limpiarFiltros() {
  this.codigosFiltrados = [];
  this.rastreoFiltradoList = this.rastreoList;
  this.collapsedStates = this.rastreoFiltradoList.map(() => true);

  this.rastreoExpandido = null;
  this.formDestino.patchValue({ estado: null, ciudad: null });
}

eliminarRastreo(codigo: string) {
    // 📊 Evento Analytics: rastreo eliminado
    this.analytics.event('rastreo_removido', {
      codigo // código del rastreo eliminado
    });

  this.codigosFiltrados = this.codigosFiltrados.filter(c => c !== codigo);
  this.rastreoFiltradoList = this.rastreoFiltradoList.filter(r => r.numrastreo !== codigo);
  this.collapsedStates = this.rastreoFiltradoList.map(() => true);
  this.guardarFiltradosEnLocalStorage();

  if (!this.rastreoFiltradoList.length) {
    this.rastreoExpandido = null;
    this.formDestino.patchValue({ estado: null, ciudad: null });
  }
}

guardarFiltradosEnLocalStorage() {
  localStorage.setItem('rastreosFiltrados', JSON.stringify({
    codigos: this.codigosFiltrados,
    rastreos: this.rastreoFiltradoList
  }));
}

cargarFiltradosDesdeLocalStorage() {
  const datos = localStorage.getItem('rastreosFiltrados');
  if (!datos) return;

  // const { codigos, expiracion } = JSON.parse(datos);

  const { codigos } = JSON.parse(datos) as { codigos: string[] };
  this.codigosFiltrados = codigos || [];

  // ⏰ Si expiró, se limpia
  // if (new Date().getTime() >= expiracion) {
  //   localStorage.removeItem('rastreosFiltrados');
  //   return;
  // }

  this.codigosFiltrados = codigos || [];
  this.collapsedStates = [];
  this.rastreoFiltradoList = [];

  let destinosCargados = false; // ← para evitar múltiples llamadas

  for (const codigo of this.codigosFiltrados) {
    this.rastreoService.track_pack2(codigo).subscribe({
      next: (response: any[]) => {
        if (!response || response.length === 0) return;

        const data = response[0];
        const ultPaso = [...data.historial].reverse().find(p => p.MensageCliente?.trim());

        const timeline = data.historial
          .filter(item => item.MensageCliente && item.MensageCliente.trim() !== '')
          .map((item: any) => {
            const fechaHora = item.fchlegible || `${item.fechamov} ${item.horamov}`;
            return {
              titulo: item.MensageCliente.trim(),
              ubicacion: item.UbicacionLegible || item.ubicacion,
              fechaHora,
              completado: true,
            };
          });

        const nuevoRastreo = {
          numrastreo: data.code,
          estatus: ultPaso?.MensageCliente || 'Sin información',
          origen: data.origen,
          destino: data.destino,
          timeline,
          entregaEstimada: data.fecha,
          remitente: data.remitente,
          destinatario: data.destinatario,
          cantidad: data.cant,
          tipoPaquete: data.envio,
          tipoEnvio: data.tipo,
          rastreoExt: data.rastreoExt,
          direccionActual: data.direccionActual,
          idedo: data.idedo,
          idcd: data.idcd,
          estado: data.Estado,
          ciudad: data.Ciudad,
          entrega: data.entrega,
          dispEntDm: data.dispEntDm,
          tipoServicio: data.TipoServicio,
           // (opcional) helper numérico para evitar strings vacíos
          entregaLat: data?.entrega?.lat ? Number(data.entrega.lat) : null,
          entregaLng: data?.entrega?.lng ? Number(data.entrega.lng) : null,
        };

        //  Evitar duplicados
        if (this.rastreoFiltradoList.some(r => r.numrastreo === nuevoRastreo.numrastreo)) {
          return;
        }

        this.rastreoFiltradoList.push(nuevoRastreo);
        this.collapsedStates.push(true);

        // Establecer el primer rastreo expandido y actualizar menú
        if (!this.rastreoExpandido) {
          this.rastreoExpandido = nuevoRastreo;
          this.actualizarFormDesdeRastreo(nuevoRastreo);
          this.actualizarOpcionesVisibles();
          this.cargarIncidenciaParaRastreoActual();

          //  Cargar destinos solo una vez
          if (!destinosCargados) {
            const idedo = Number(nuevoRastreo.idedo);
            const idcd  = Number(nuevoRastreo.idcd);
            this.cargarDestinos(idedo, idcd);
            destinosCargados = true;
          }
        }
      },
      error: () => {
        console.warn(`No se pudo cargar el rastreo para el código ${codigo}`);
      }
    });
  }
}


rastreosFiltradosPorTexto() {
  const texto = this.codigoBusqueda?.trim().toLowerCase() || '';
  if (!texto) return this.rastreoFiltradoList;

  return this.rastreoFiltradoList.filter(r =>
    r.numrastreo.toLowerCase().includes(texto)
  );
}

onFileSelected(event: Event): void {
  const input = event.target as HTMLInputElement;
  const files = input.files;
  if (!files) return;

  const newFiles = Array.from(files).filter(f => f.type.startsWith('image/'));
  const totalImages = this.imagePreviews.length + newFiles.length;

  if (totalImages > this.maxImages) {
    Swal.fire({
      icon: 'warning',
      title: 'Límite de imágenes',
      html: `Solo puedes subir un máximo de <b>${this.maxImages}</b> imágenes.`,
      timer: 3000,
      timerProgressBar: true,
      showConfirmButton: false,
      customClass: { popup: 'swal-custom-font' }
    });
    // Limpia el input para permitir volver a seleccionar
    input.value = '';
    return;
  }

  for (const file of newFiles) {
    const reader = new FileReader();
    reader.onload = () => {
      const dataUrl = reader.result as string; // "data:image/...;base64,...."
      const safeUrl = this.sanitizer.bypassSecurityTrustUrl(dataUrl);
      // Si tu tipo es { url: string, file: File }, puedes castear:
      this.imagePreviews.push({ url: safeUrl as any, file });
    };
    reader.readAsDataURL(file);
  }

  // Resetear input para permitir subir el mismo archivo si se elimina
  input.value = '';
}

  removeImage(index: number): void {
    this.imagePreviews.splice(index, 1);
  }

  mostrarDetalles() {
  this.mostrarRightContainer = true;
  
}
  ocultarDetalles() {
    this.mostrarRightContainer = false;
}
verDetalles(index: number) {
  this.mostrarDetalles();
  this.toggleCollapse(index);
}

  obtenerCodigo() {
    const valor = this.telefono_mail.trim();

    const esTelefonoValido = /^\d{10}$/.test(valor);
    const esEmailValido = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(valor);

    if (esTelefonoValido || esEmailValido) {
      // this.mostrarCodigo = true;
       this.hidratarEvidenciaDesdeRastreo();
      this.mostrarEvidencia = true;
    } else {
      alert('Por favor, ingresa un número de teléfono válido de 10 dígitos o un correo electrónico válido.');
    }
  }

getUltimaUbicacion(rastreo: any): string | null {
  // console.log('getUltimaUbicacion - rastreo:', rastreo);

  if (!rastreo) {
    // console.log('No hay rastreo');
    return null;
  }
  if (!rastreo.timeline) {
   // console.log('No tiene propiedad timeline');
    return null;
  }
  if (!Array.isArray(rastreo.timeline)) {
   // console.log('timeline no es un arreglo');
    return null;
  }
  if (rastreo.timeline.length === 0) {
   // console.log('timeline está vacío');
    return null;
  }

  const ultima = rastreo.timeline[rastreo.timeline.length - 1];
 // console.log('Última entrada timeline:', ultima);

  // Aquí haces la validación si la última ubicación es "ENTREGA"
  if (ultima.ubicacion && ultima.ubicacion.toUpperCase() === 'ENTREGA') {
    console.log('Última ubicación es ENTREGA, usando destino:', rastreo.destino);
    return rastreo.destino || null;
  }

  console.log('Última ubicación normal:', ultima.ubicacion);
  return ultima.ubicacion || null;
}

// getMapaUrl(ubicacion: string | null): SafeResourceUrl {
//   if (!ubicacion) return this.sanitizer.bypassSecurityTrustResourceUrl('');

//   const encoded = encodeURIComponent(ubicacion.trim());
//   return this.sanitizer.bypassSecurityTrustResourceUrl(
//     `https://www.google.com/maps/embed/v1/place?key=AIzaSyCyf5AM3wZYVE2fpG1Raus1Gbbuvdot79w&q=${encoded}`
//   );
// }

esUltimoCompletado(timeline: any[], index: number): boolean {
  const indicesCompletados = timeline
    .map((p, i) => (p.completado ? i : -1))
    .filter(i => i !== -1);

  const ultimoIndex = Math.max(...indicesCompletados);
  return index === ultimoIndex;
}

obtenerUltimoTituloCompletado(timeline: any[]): string {
  const completados = timeline.filter(p => p.completado);
  return completados.length > 0 ? completados[completados.length - 1].titulo : 'Sin estatus';
}

// seleccionarDestino(destino: any) {
//     this.destinos.forEach(d => d.esDestinoActual = false);
//     destino.esDestinoActual = true;
//     this.destinoSeleccionado = destino;
// }

addnewdestino() {
  if (this.formDestino.invalid) { this.formDestino.markAllAsTouched(); return; }

  const raw = this.formDestino.getRawValue();
  const idcliente = this.idcliente;
  const iddir = 0;
  const idedo = Number(raw.estado);
  const idcd  = Number(raw.ciudad);
  const idcol = this.formDestino.value.colonia as number;

  const nombre     = String(this.formDestino.value.nombre ?? '').trim();
  const correo     = String(this.formDestino.value.correo ?? '').trim();
  const tel        = String(this.formDestino.value.telefono ?? '').trim();
  const direccion  = String(this.formDestino.value.direccion ?? '').trim();
  const referencia = String(this.formDestino.value.referencia ?? '').trim();

  this.rastreoService.guardarDireccionALT(
    idcliente, iddir, idedo, idcd, idcol, nombre, correo, tel, direccion, referencia
  ).subscribe({
    next: (resp /*: { Text: string } */) => {
        // 📊 Evento: solo si se agregó exitosamente
      this.analytics.event('destino_agregado', {
        id_cliente: idcliente,
        id_estado: idedo,
        id_ciudad: idcd,
        id_colonia: idcol
      });

      Swal.fire({
        icon:'success',
        title: resp?.Text || 'Operación exitosa',
        timer:3000,
        timerProgressBar:true,
        showConfirmButton:false,
        customClass:{ popup:'swal-custom-font' }
      });

      // Reset del form conservando edo/cd
      this.formDestino.reset({
        estado: { value: raw.estado, disabled: true },
        ciudad: { value: raw.ciudad, disabled: true },
        colonia: null, nombre:'', correo:'', telefono:'', direccion:'', referencia:''
      }, { emitEvent:false });

      // 👇 Recarga y luego predetermina el más nuevo (mayor id)
      this.cargarDestinos(idedo, idcd, () => {
        const candidato = [...this.destinos].sort((a, b) => Number(b.id) - Number(a.id))[0];
        if (candidato?.id) {
          this.predeterminarPorId(Number(candidato.id), idedo, idcd);
        }
      });
    },
    error: (err) => {
      const msg = err?.error?.Text || 'No se pudo guardar el destino. Intenta nuevamente.';
      Swal.fire({ icon:'error', title:'Error', text: msg, customClass:{ popup:'swal-custom-font' } });
    }
  });
}

eliminarDestino(destino: any) {
  const iddir = destino?.id ?? destino?._raw?.iddir;
  if (!iddir) {
    // console.warn('No se obtuvo iddir del destino:', destino);
    return;
  }

  // Confirmación
  Swal.fire({
    icon: 'warning',
    title: 'Eliminar domicilio',
    text: '¿Deseas eliminar este domicilio?',
    showCancelButton: true,
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar',
    customClass: { popup: 'swal-custom-font' }
  }).then(res => {
    if (!res.isConfirmed) return;

    this.eliminandoId = Number(iddir);

    const idcliente = this.idcliente;

    this.rastreoService.eliminarDireccion(idcliente, iddir).subscribe({
      next: (resp) => {
        Swal.fire({
          icon: 'success',
          title: resp?.Text || 'Operación exitosa',
          timer: 2000,
          timerProgressBar: true,
          showConfirmButton: false,
          customClass: { popup: 'swal-custom-font' }
        });

        // refrescar lista usando el filtro actual (idedo/idcd del rastreo o del propio destino)
        const idedo = Number(this.rastreoExpandido?.idedo ?? destino?._raw?.idedo ?? 0);
        const idcd  = Number(this.rastreoExpandido?.idcd  ?? destino?._raw?.idcd  ?? 0);
        this.cargarDestinos(idedo, idcd);
      },
      error: (err) => {
        Swal.fire({
          icon: 'error',
          title: 'Error al eliminar',
          text: err?.error?.Text || 'Inténtalo nuevamente.',
          customClass: { popup: 'swal-custom-font' }
        });
      },
      complete: () => {
        this.eliminandoId = null;
      }
    });
  });
}

onSubmitAsistencia() {
  if (this.formAsistencia.invalid) {
    this.formAsistencia.markAllAsTouched();
    return;
  }

  const idcliente = this.idcliente;
  const { nombre, correo, telefono, tema, mensaje } = this.formAsistencia.value;

  const idtema = Number(tema);
  if (!idtema) {
    this.formAsistencia.get('tema')?.markAsTouched();
    return;
  }

  const rastreo = String(this.rastreoExpandido?.numrastreo || '').trim();
  if (!rastreo) {
    Swal.fire({
      icon: 'warning',
      title: 'Selecciona un envío',
      text: 'Abre un rastreo para poder asociar tu solicitud.',
      customClass: { popup: 'swal-custom-font' }
    });
    return;
  }

  this.rastreoService.guardarSolicitudAsistencia(
    idcliente,
    String(nombre ?? '').trim(),
    String(correo ?? '').trim(),
    String(telefono ?? '').trim(),
    idtema,
    String(mensaje ?? '').trim(),
    rastreo
  ).subscribe({
    next: (resp) => {
      // 📊 Evento GA4/GTM: solicitud asistencia enviada
      this.analytics.event('solicitud_asistencia', {
        idcliente,
        correo,
        telefono,
        rastreo
      });

      Swal.fire({
        icon: 'success',
        title: resp?.Text || 'Operación exitosa',
        timer: 3000,
        timerProgressBar: true,
        showConfirmButton: false,
        customClass: { popup: 'swal-custom-font' }
      }).then(() => {
        this.formAsistencia.reset({
          nombre: '',
          correo: '',
          telefono: '',
          tema: null,        // placeholder visible
          mensaje: ''
        });
      });
    },
    error: (err) => {
      const msg = err?.error?.Text || 'Inténtalo nuevamente más tarde.';
      Swal.fire({
        icon: 'error',
        title: 'Error al guardar',
        text: msg,
        customClass: { popup: 'swal-custom-font' }
      });
    }
  });
}


  onMedioSeleccionado() {
  this.valorMedio = '';
  this.mostrarCodigo = false;
  this.mostrarEvidencia = false;
  this.codigo = ['', '', '', ''];
}

activarNotificacion() {
  if (this.medioSeleccionado && this.valorMedio && this.esMedioValido) {
    const tipo = this.medioSeleccionado;
    const referencia = encodeURIComponent(this.valorMedio);
    const idcliente = this.idcliente;

    this.rastreoService.activarNotificacion(idcliente, tipo, referencia).subscribe({
      next: (response) => {

        // 📊 Evento GA4/GTM: notificación activada exitosamente
        this.analytics.event('notificacion_activada', {
          via: tipo,                              // vía: correo / sms / whatsapp
          medio: this.valorMedio                // valor del medio (email o número)
        });

        Swal.fire({
          icon: 'success',
          title: response.Text,
          html: `Vía <strong>${tipo.toUpperCase()}</strong> para: <strong>${this.valorMedio}</strong>`,
          showConfirmButton: true,
          customClass: { popup: 'swal-custom-font' }
        }).then(() => this.resetFormularioNotif());

        // 🔄 Recargar el medio actual para mostrar el bloque superior
        this.cargarConfigNotificaciones();
      },
      error: (error) => {
        //console.error('Error al activar notificación', error);
        Swal.fire({
          icon: 'error',
          title: 'Error al activar notificación',
          text: 'Intente nuevamente más tarde.',
        });
      }
    });
  }
}

  resetFormularioNotif(): void {
  this.medioSeleccionado = null;
  this.valorMedio = '';
  this.mostrarEvidencia = false;
  this.codigo = ['', '', '', '']; // si estás usando campos de verificación
}

validarCodigoEvicencia() {
  const codigoCorrecto = ['1', '2', '3', '4'];
  const esCodigoValido = this.codigo.join('') === codigoCorrecto.join('');

  if (esCodigoValido) {
    // Mostrar evidencia y ocultar el input de código
    this.mostrarEvidencia = true;
    this.mostrarCodigo = false;

    Swal.fire({
      icon: 'success',
      title: '¡Código correcto!',
      text: 'Se muestra la evidencia de entrega.',
      confirmButtonText: 'Aceptar',
      customClass: {
        popup: 'swal-custom-font'
  }
    });
  } else {
    Swal.fire({
      icon: 'error',
      title: 'Código incorrecto',
      text: 'El código ingresado no es válido. Inténtalo de nuevo.',
      confirmButtonText: 'Reintentar',
        customClass: {
    popup: 'swal-custom-font'
  }   
    });
  }
}

get esMedioValido(): boolean {
  if (this.medioSeleccionado === 'correo') {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.valorMedio);
  }
  if (this.medioSeleccionado === 'whatsapp' || this.medioSeleccionado === 'sms') {
    return /^\d{10}$/.test(this.valorMedio);
  }
  return false;
}

validarCodigo() {
  const codigoCorrecto = ['1', '2', '3', '4'];
  const esCodigoValido = this.codigo.join('') === codigoCorrecto.join('');

  if (this.esMedioValido) {
    // ✅ Confirmación con SweetAlert2
    Swal.fire({
      icon: 'success',
      title: '¡Notificación activada!',
      html: `Se activaron las notificaciones vía <b>${this.medioSeleccionado.toUpperCase()}</b> para:<br><strong>${this.valorMedio}</strong>`,
      confirmButtonText: 'Aceptar',
        customClass: {
    popup: 'swal-custom-font'
  }   
    });

    this.mostrarEvidencia = false;
    this.mostrarCodigo = false;
    this.codigo = ['', '', '', ''];
    this.valorMedio = '';
    this.medioSeleccionado = null;
  } else {
    // ❌ Código incorrecto
    Swal.fire({
      icon: 'error',
      title: 'Código incorrecto',
      text: 'El código ingresado no es válido. Inténtalo de nuevo.',
      confirmButtonText: 'Reintentar',
        customClass: {
    popup: 'swal-custom-font'
  }
    });
  }
}



enviarIncidencia() {
  this.mensajeIncidenciaExito = false;
  this.mensajeIncidenciaError = false;

  // 1) Validaciones básicas
  const mensaje = (this.mensajeTexto || '').trim();
  const tieneArchivos = this.imagePreviews.length > 0;

  // rastreo del envío abierto (necesario para el endpoint)
  const rastreo = String(this.rastreoExpandido?.numrastreo || '').trim();
  if (!rastreo) {
    Swal.fire({ icon: 'error', title: 'Falta rastreo', text: 'No hay un envío seleccionado.', customClass: { popup: 'swal-custom-font' } });
    return;
  }

  // tema puede venir como texto (t.tema) o como id (t.idtema): resolvemos a idtema
  const idtema = (typeof this.temaSeleccionado === 'number')
    ? this.temaSeleccionado
    : (this.temasIncidencia.find(t => t.tema === this.temaSeleccionado)?.idtema ?? null);

  if (!idtema || !mensaje) {
    Swal.fire({
      icon: 'error',
      title: 'Campos incompletos',
      text: 'Selecciona un tema y escribe el mensaje para continuar.',
      customClass: { popup: 'swal-custom-font' }
    });
    return;
  }

  // 2) Crear incidencia
  const idusr = this.idcliente; // tu id dinámico desde el token
  this.rastreoService.registrarIncidencia(rastreo, idusr, idtema, mensaje).subscribe({
    next: (respInc) => {

      // 📊 Evento GA4/GTM: incidencia registrada (solo en éxito de creación)
  this.analytics.event('incidencia_registrada', {
    iduser: idusr,     // id del usuario/cliente
    rastreo, 
    tema: this.temaSeleccionado 
  });
      // La API regresa ref = id del mensaje/conversación donde colgaremos los adjuntos
      const idmensaje = respInc?.ref;
      if (!idmensaje) {
        Swal.fire({ icon: 'error', title: 'Error', text: 'No se obtuvo la referencia de la incidencia.', customClass: { popup: 'swal-custom-font' } });
        return;
      }

      // 3) Subir adjuntos (en paralelo)
      const uploads = this.imagePreviews.slice(0, this.maxImages).map((img, idx) => {
        const dataUrl = String(img.url || '');
        const base64 = dataUrl.includes(',') ? dataUrl.split(',')[1] : dataUrl; // quitar prefijo data:
        const x = base64.split('(see')[0];
        const nombre = (img.file?.name || `evidencia_${idx + 1}.png`);
        return this.rastreoService.adjuntarIncidenciaALT({
          idmensaje,
          tipo: 'IMG',
          nombrearchivo: nombre,
          archivo: x
        });
      });

      forkJoin(uploads).subscribe({
        next: () => {
          // 4) Éxito total: mostramos mensaje del backend de la primera llamada
          Swal.fire({
            icon: 'success',
            title: respInc?.msg || 'Operación exitosa',
            timer: 2500,
            timerProgressBar: true,
            showConfirmButton: false,
            customClass: { popup: 'swal-custom-font' }
          });
            this.cargarIncidenciaParaRastreoActual();
          // Mostramos vista de detalle (incidencia === 1) y conservamos previews para esa vista
          this.incidencia = 1;
        

          // Limpia solo campos del formulario de incidencia (deja imágenes para mostrar en la sección siguiente)
          this.temaSeleccionado = null;
          this.mensajeTexto = '';
        },
        error: (errUp) => {
          const msg = errUp?.error?.msg || 'No se pudieron subir las evidencias.';
          Swal.fire({ icon: 'error', title: 'Adjuntos', text: msg, customClass: { popup: 'swal-custom-font' } });
        }
      });
    },
    error: (errInc) => {
      const msg = errInc?.error?.msg || 'No se pudo registrar la incidencia.';
      Swal.fire({ icon: 'error', title: 'Error', text: msg, customClass: { popup: 'swal-custom-font' } });
    }
  });
}

seleccionarEstado(estado: string) {
  this.formDestino.patchValue({ ciudad: '', colonia: '' });
  this.ciudades = this.domicilios
    .filter(d => d.estado === estado)
    .map(d => d.ciudad)
    .filter((v,i,a) => a.indexOf(v) === i);
}

// seleccionarCiudad(ciudad: string) {
//   this.formDestino.patchValue({ colonia: '' });
//   this.colonias = this.domicilios
//     .filter(d => d.ciudad === ciudad)
//     .map(d => d.asenta)
//     .filter((v,i,a) => a.indexOf(v) === i);
// }

// 1) Llama a esto en filtrarPorCodigo:
private cargarDomicilios(codigo: string) {
  this.rastreoService.getDomicilios(codigo).subscribe({
    next: cols => {
      // console.log('DOMICILIOS recibidos:', cols);    // ← DOMICILIOS aquí
      this.domicilios = cols;

      this.estados = [];
      for (const d of cols) {
        if (!this.estados.includes(d.estado)) {
          this.estados.push(d.estado);
        }
      }
      // console.log('ESTADOS calculados:', this.estados); // ← y aquí para verificar

      // resetea selects
      this.ciudades = [];
      this.colonias = [];
   this.formDestino.patchValue({ colonia: '' }, { emitEvent: false });
    },
    error: () => console.error('No se pudo cargar domicilios')
  });
}

// 2) Manejo de cambios en los selects:
public onEstadoChange(estado: string) {
  this.formDestino.patchValue({ ciudad: '', colonia: '' });
  this.ciudades = [];
  for (const d of this.domicilios) {
    if (d.estado === estado && !this.ciudades.includes(d.ciudad)) {
      this.ciudades.push(d.ciudad);
    }
  }
}

// public onCiudadChange(ciudad: string) {
//   this.formDestino.patchValue({ colonia: '' });
//   this.colonias = [];
//   for (const d of this.domicilios) {
//     if (d.ciudad === ciudad && !this.colonias.includes(d.asenta)) {
//       this.colonias.push(d.asenta);
//     }
//   }
// }

validarLoginYMostrarDestino() {
  const token = sessionStorage.getItem("token");
  if (token) {
    this.token = token;
    try {
      this.userGw = jwt_decode(this.token);
      this.idcliente = this.userGw.idUser;
      this.isLoguedin = true;
    } catch (e) {
      this.isLoguedin = false;
      this.router.navigate(["/herramientasDigitales/login"], { queryParams: { to: 'rastreo-envios' } });
    }
  } else {
    this.isLoguedin = false;
    this.router.navigate(["/herramientasDigitales/login"], { queryParams: { to: 'rastreo-envios' } });
  }
}

isRastreoExpandidoVisible(): boolean {
  if (!this.rastreoExpandido) return false;

  const index = this.rastreoFiltradoList.findIndex(
    r => r.numrastreo === this.rastreoExpandido.numrastreo
  );

  return index !== -1 && !this.collapsedStates[index];
}

versegincidencia() {
  const idincidencia = this.incidenciaDetalle?.idincidencia;
  if (idincidencia) {
    this.cargarMensajesIncidencia(idincidencia);
  }
}

generateCalendar(date: Date): void {
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    const calendar: Date[][] = [];
    let week: Date[] = [];

    // Posicionar el primer día
    for (let i = 0; i < firstDay.getDay(); i++) {
      week.push(null!); // Espacios vacíos
    }

    for (let day = 1; day <= lastDay.getDate(); day++) {
      const dayDate = new Date(date.getFullYear(), date.getMonth(), day);
      week.push(dayDate);

      if (week.length === 7) {
        calendar.push(week);
        week = [];
      }
    }

    if (week.length > 0) {
      while (week.length < 7) {
        week.push(null!);
      }
      calendar.push(week);
    }

    this.weeks = calendar;
  }

   selectDate(date: Date) {
    if (date) {
      this.selectedDate = date;
      // console.log('Fecha seleccionada:', date);
    }
  }

  prevMonth() {
    this.currentDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() - 1, 1);
    this.generateCalendar(this.currentDate);
  }

  nextMonth() {
    this.currentDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 1);
    this.generateCalendar(this.currentDate);
  }


cargarTemasAsist(): void {
  // Usa el método del servicio para obtener temas por tipo.
  // NO cambiamos el servicio, solo pasamos 'ATN' desde aquí.
  this.rastreoService.obtenerTemasIncidencia('ATN').subscribe({
    next: (data) => {
      this.temas = Array.isArray(data) ? data : [];
    },
    error: () => {
      this.temas = [];
    }
  });
}

private cargarTemasIncidencia(): void {
  this.rastreoService.obtenerTemasIncidencia('INC').subscribe({
    next: (data) => this.temasIncidencia = Array.isArray(data) ? data : [],
    error: () => this.temasIncidencia = []
  });
}
// Opcional: performance en *ngFor
trackTema = (_: number, t: any) => t.idtema;


cargarDestinos(idedo: number, idcd: number, afterLoad?: () => void) {
  this.cargandoDestinos = true;
  this.rastreoService.getDomiciliosListPorEdoCd(this.idcliente, idedo, idcd)
    .subscribe({
      next: (resp) => this.hidratarDestinos(resp),
      error: () => { this.destinos = []; this.destinoSeleccionado = null; },
      complete: () => {
        this.cargandoDestinos = false;
        if (afterLoad) afterLoad();            // ejecuta callback al terminar
      }
    });
}

// factoriza el mapeo/orden en un método reutilizable
private hidratarDestinos(resp: any[]) {
  const lista = Array.isArray(resp) ? resp : [];

  this.destinos = lista
    .map(d => ({
      id: d.iddir,
      nombre: d.nombre ??'',
      direccion: d.direccion ?? '',
      cp: d.CP ?? '',
      ciudad: `${d.Ciudad ?? ''}, ${d.Estado ?? ''}`.replace(/^, |, $/g, ''),
      esDestinoActual: d.predeterminado === 1,
      _raw: d
    }))
    .sort((a, b) => (Number(b.esDestinoActual) - Number(a.esDestinoActual)) || (b.id - a.id));

  const ultimoId = localStorage.getItem('ultimoDirSel');
  const prefer = ultimoId ? this.destinos.find(x => String(x.id) === String(ultimoId)) : null;
  const marcados = this.destinos.filter(x => x.esDestinoActual);

  if (prefer) {
    this.destinos.forEach(d => d.esDestinoActual = String(d.id) === String(prefer!.id));
  } else if (marcados.length > 1) {
    const ganador = marcados[0];
    this.destinos.forEach(d => d.esDestinoActual = d === ganador);
  } else if (!marcados.length && this.destinos.length) {
    this.destinos[0].esDestinoActual = true;
  }

  this.destinoSeleccionado = this.destinos.find(x => x.esDestinoActual) || null;
}

trackById = (_: number, item: any) => item.id ?? item.direccion;


seleccionarDestino(destino: any) {
  if (this.guardandoPredeterminado || destino.esDestinoActual) return;

  const seleccionadoId = destino.id ?? destino._raw?.iddir;
  if (!seleccionadoId) {
    // console.warn('No se obtuvo iddir del destino:', destino);
    return;
  }

  const rastreo = String(this.rastreoExpandido?.numrastreo ?? '').trim();
  if (!rastreo) {
    Swal.fire({
      icon: 'error',
      title: 'No se pudo predeterminar',
      text: 'No hay un código de rastreo activo.',
      customClass: { popup: 'swal-custom-font' }
    });
    return;
  }

  // Guarda el previo para poder revertir si falla
  const previoSeleccionado = this.destinoSeleccionado?.id ?? null;

  // UI optimista
  this.destinos.forEach((d: any) => d.esDestinoActual = String(d.id) === String(seleccionadoId));
  this.destinoSeleccionado = this.destinos.find((d: any) => String(d.id) === String(seleccionadoId));
  this.guardandoPredeterminado = true;

  this.rastreoService
    .predeterminarDireccion(String(seleccionadoId), String(this.idcliente), rastreo)
    .subscribe({
      next: (resp) => {
        // Persistir preferencia local SOLO si el backend confirmó
        localStorage.setItem('ultimoDirSel', String(seleccionadoId));
        this.guardandoPredeterminado = false;

        // ✅ Mostrar mensaje del backend
        Swal.fire({
          icon: 'success',
          title: resp?.Text || 'Operación exitosa',
          timer: 2000,
          timerProgressBar: true,
          showConfirmButton: false,
          customClass: { popup: 'swal-custom-font' }
        });
      },
      error: (err) => {
        const msg = err?.error?.Text || 'No se pudo establecer el destino como predeterminado.';
        //console.error('Error al predeterminar dirección', err);

        // Revertir UI
        this.destinos.forEach((d: any) => d.esDestinoActual = String(d.id) === String(previoSeleccionado));
        this.destinoSeleccionado = this.destinos.find((d: any) => String(d.id) === String(previoSeleccionado)) || null;

        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: msg,
          customClass: { popup: 'swal-custom-font' }
        });

        this.guardandoPredeterminado = false;
      }
    });
}

private predeterminarPorId(iddir: number, idedo: number, idcd: number) {
  const rastreo = String(this.rastreoExpandido?.numrastreo ?? '').trim();
  if (!iddir || !rastreo) return;

  this.guardandoPredeterminado = true;

  // UI optimista (por si ya está en memoria)
  this.destinos.forEach(d => d.esDestinoActual = String(d.id) === String(iddir));
  this.destinoSeleccionado = this.destinos.find(d => String(d.id) === String(iddir)) || this.destinoSeleccionado;

  this.rastreoService
    .predeterminarDireccion(String(iddir), String(this.idcliente), rastreo)
    .subscribe({
      next: () => {
        localStorage.setItem('ultimoDirSel', String(iddir));
        // Refresca la lista del backend (ya vendrá marcado predeterminado)
        this.cargarDestinos(idedo, idcd, () => {
          // Asegura selectedDestino sincronizado con el que vino del backend
          const sel = this.destinos.find(d => d.esDestinoActual);
          if (sel) this.destinoSeleccionado = sel;
          this.guardandoPredeterminado = false;
        });
      },
      error: () => {
        this.guardandoPredeterminado = false;
        // (opcional) podría revertirse la UI, pero al recargar lista quedará consistente
      }
    });
}

private actualizarFormDesdeRastreo(r: any) {
  if (!r) return;

  const idedo = r.idedo != null ? +r.idedo : null;
  const idcd  = r.idcd  != null ? +r.idcd  : null;

  this.formDestino.patchValue({ estado: idedo, ciudad: idcd });

  if (idedo != null && idcd != null) {
    this.cargarColoniasPorIds(idedo, idcd);
  }
}

private cargarColoniasPorIds(idedo: number, idcd: number) {
  if (idedo == null || idcd == null) return;

  // deja el control en null para que se muestre el placeholder
  this.formDestino.patchValue({ colonia: null }, { emitEvent: false });
  this.colonias = [];

  this.rastreoService.getColonias(idedo, idcd).subscribe({
    next: (cols: any[]) => {
      this.colonias = (cols || [])
        .map(x => ({
          idcol: +(x.idcol ?? x.IdCol ?? x.idcolonia ?? 0),
          asenta: String(x.asenta ?? x.Asenta ?? x.colonia ?? '').trim()
        }))
        .filter(c => c.idcol && c.asenta)
        .filter((c, i, a) => a.findIndex(z => z.idcol === c.idcol) === i);

      // NO auto-seleccionar:
      // if (this.colonias.length === 1) {
      //   this.formDestino.patchValue({ colonia: this.colonias[0].idcol });
      // }
    },
    error: (e) => {
      // console.error('Error cargando colonias', e);
      this.colonias = [];
    }
  });
}

private initIdClienteFromToken(): void {
  const token = sessionStorage.getItem('token');
  if (token) {
    try {
      const u: any = jwt_decode(token);
      this.idcliente = Number(u.idUser) || 1;
      this.isLoguedin = true;
    } catch {
      this.idcliente = 1;
      this.isLoguedin = false;
    }
  } else {
    this.idcliente = 1;
    this.isLoguedin = false;
  }
}

private cargarIncidenciaParaRastreoActual(): void {
  const rastreo = String(this.rastreoExpandido?.numrastreo || '').trim();
  const idusr = this.idcliente; // dinámico desde token

  // Si no hay rastreo seleccionado aún, muestra el formulario (incidencia === 0)
  if (!rastreo) {
    this.incidencia = 0;
    this.incidenciaDetalle = null;
    // limpia el form por si viene de otra incidencia
    this.reclamacionForm.reset();
    return;
  }

  // Helper local para inferir el MIME por extensión
  const inferMime = (nombre?: string): string => {
    const ext = (nombre || '').split('.').pop()?.toLowerCase();
    switch (ext) {
      case 'png':  return 'image/png';
      case 'jpg':
      case 'jpeg': return 'image/jpeg';
      case 'gif':  return 'image/gif';
      case 'webp': return 'image/webp';
      default:     return 'image/jpeg'; // fallback
    }
  };

    // helper: "" -> null (para que el input quede vacío y se vea el placeholder)
  const v = (s?: string | null) => (s && s.trim() !== '' ? s : null);

  this.rastreoService.cargarIncidencia(idusr, rastreo).subscribe({
    next: (resp: any) => {
      const hayIncidencia =
        !!resp &&
        (!!resp.mensaje || (Array.isArray(resp.adjuntos) && resp.adjuntos.length > 0));

      if (hayIncidencia) {
        // Normaliza + sanitiza adjuntos para <img [src]>
        const adjuntosOrig = Array.isArray(resp?.adjuntos) ? resp.adjuntos : [];
        const adjuntosSanitizados = adjuntosOrig.map((a: any) => {
          const mime = inferMime(a?.nombrearchivo);
          const rawUrl =
            (a?.urlarchivo && String(a.urlarchivo).trim()) ||
            (a?.archivo ? `data:${mime};base64,${a.archivo}` : '');

          const safeUrl = rawUrl ? this.sanitizer.bypassSecurityTrustUrl(rawUrl) : null;
          return { ...a, safeUrl };
        });

        this.incidenciaDetalle = { ...resp, adjuntos: adjuntosSanitizados };
        if(this.incidenciaDetalle.tipo == null){
          this.incidenciaDetalle.tipo = "";
        }
        this.incidencia = 1;
        this.setAdjuntosExistentesNoInc(this.incidenciaDetalle.adjuntos);

          // Ahora que ya existe idincidencia, carga el chat:
        const id = Number(this.incidenciaDetalle?.idincidencia || 0);
        if (id) {
          this.cargarMensajesIncidencia(id);
        }

           // <<<<<<<< PATCH DE CAMPOS DEL ENDPOINT AL FORM >>>>>>>>
        this.reclamacionForm.patchValue({
          nombrerec:          v(resp.RecNombre),
          rfcrec:             v(resp.RecRFC),
          telrec:             v(resp.Rectelefono),
          correorec:          v(resp.RecCorreo),
          identrec:           v(resp.RecIdContacto),
          telcontactorec:     v(resp.RecTelCon),
          correocontactorec:  v(resp.RecCorreoCon),
        });
        
        // (Opcional) si no quieres mezclar con imágenes locales seleccionadas para subir:
        // this.imagePreviews = [];
      } else {
        // No hay incidencia previa → muestra el formulario
        this.incidencia = 0;
        this.incidenciaDetalle = null;
        // this.imagePreviews = [];
        this.reclamacionForm.reset(); // queda todo vacío -> se ven placeholders
      }
    },
    error: () => {
      // En error, mantenemos el formulario para poder registrar una nueva
      this.incidencia = 0;
      this.incidenciaDetalle = null;
      // this.imagePreviews = [];
      this.reclamacionForm.reset();
    }
  });
}

  validaEsIncidencia() {
    if (this.incidenciaDetalle === null || this.incidenciaDetalle.tipo != "RECLAMACION") {
      return false;
    }
    else {
      if (this.incidenciaDetalle.tipo === 'RECLAMACION') {
        return true;
      }
    } 
}


  private cargarMensajesIncidencia(idincidencia: number) {
    const idusr = this.idcliente;
    this.rastreoService.cargarMensajesIncidencia(idusr, idincidencia).subscribe({
      next: (lista) => {
        this.mensajesIncidencia = Array.isArray(lista) ? lista : [];
        
      },
      error: () => {
        this.mensajesIncidencia = [];
      }
    });
  }

  enviarMensajeIncidencia() {
    const msg = (this.chatMensaje || '').trim();
    if (!msg) return;

    const idincidencia = this.incidenciaDetalle?.idincidencia;
    const rastreo = String(this.rastreoExpandido?.numrastreo || '').trim();
    const idusr = this.idcliente;

    if (!idincidencia || !rastreo) {
      Swal.fire({
        icon: 'error',
        title: 'Faltan datos',
        text: 'No se encontró la incidencia o el rastreo.',
        customClass: { popup: 'swal-custom-font' }
      });
      return;
    }

    this.enviandoMsg = true;

    // Preview optimista
    const preview = {
      idmensaje: 0,
      mensaje: msg,
      usuario: String(idusr),
      nombre: 'YO',
      fecha: this.formateaAhora()
    };
    this.mensajesIncidencia = [...this.mensajesIncidencia, preview];

    this.rastreoService.enviarMensajeIncidencia(idincidencia, rastreo, idusr, msg).subscribe({
      next: (resp) => {
        if (String(resp?.num) !== '1') {
          // Revertir preview y avisar
          this.mensajesIncidencia = this.mensajesIncidencia.filter(m => m !== preview);
          Swal.fire({
            icon: 'error',
            title: 'No se pudo enviar',
            text: resp?.msg || 'Inténtalo de nuevo.',
            customClass: { popup: 'swal-custom-font' }
          });
          return;
        }
        // Éxito → limpiar input y recargar historial real
        this.chatMensaje = '';
        this.cargarMensajesIncidencia(idincidencia);
      },
      error: () => {
        // Revertir preview y avisar
        this.mensajesIncidencia = this.mensajesIncidencia.filter(m => m !== preview);
        Swal.fire({
          icon: 'error',
          title: 'Error de red',
          text: 'No se pudo enviar el mensaje.',
          customClass: { popup: 'swal-custom-font' }
        });
      },
      complete: () => {
        this.enviandoMsg = false;
      }
    });
  }

  private formateaAhora(): string {
    const d = new Date();
    const pad = (n: number) => (n < 10 ? `0${n}` : String(n));
    return `${d.getFullYear()}/${pad(d.getMonth() + 1)}/${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }

   isYo(m: any): boolean {
    const nombre = String(m?.nombre || '').trim().toUpperCase();
    return nombre === 'USUARIO WEB';
  }

  isSoporte(m: any): boolean {
    const nombre = String(m?.nombre || '').trim().toUpperCase();
    return nombre !== 'USUARIO WEB';
  } 

  trackMsg = (_: number, m: any) => m.idmensaje ?? m.fecha ?? _;


  cargarTemasMotivos(): void {
  this.rastreoService.obtenerTemasMotivos().subscribe({
    next: (data) => { this.motivos = Array.isArray(data) ? data : []; },
    error: (e) => { console.error('Error cargando motivos', e); this.motivos = []; }
  });
}

cargarRangosHorarios(): void {
  this.rastreoService.obtenerRangosHorarios().subscribe({
    next: (data) => {
      this.rangosHorarios = Array.isArray(data) ? data : [];
      // Si quieres evitar duplicados por texto, descomenta:
      // this.rangosHorarios = this.rangosHorarios.filter(
      //   (r, i, arr) => arr.findIndex(x => x.tema === r.tema) === i
      // );
    },
    error: (e) => {
     // console.error('Error cargando rangos horarios', e);
      this.rangosHorarios = [];
    }
  });
}


private formatYYYYMMDD(d: Date): string {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}${mm}${dd}`;
}

programarEntrega(): void {
  const rastreo = String(this.rastreoExpandido?.numrastreo || '').trim();
  if (!rastreo) {
    Swal.fire({
      icon: 'warning',
      title: 'Selecciona un envío',
      text: 'Primero busca y selecciona un código de rastreo.',
      timer: 2500,
      showConfirmButton: false
    });
    return;
  }

  if (!this.selectedDate) {
    Swal.fire({
      icon: 'warning',
      title: 'Fecha requerida',
      text: 'Selecciona una fecha en el calendario.',
      timer: 2500,
      showConfirmButton: false
    });
    return;
  }

  if (!this.motivoSeleccionado) {
    Swal.fire({
      icon: 'warning',
      title: 'Motivo requerido',
      text: 'Selecciona un motivo.',
      timer: 2500,
      showConfirmButton: false
    });
    return;
  }

  if (!this.rangoSeleccionado) {
    Swal.fire({
      icon: 'warning',
      title: 'Rango horario requerido',
      text: 'Selecciona un rango de hora.',
      timer: 2500,
      showConfirmButton: false
    });
    return;
  }

  // Motivo y Rango pueden estar como id (number) o texto (string) según tu [ngValue].
  // Mapea a texto si vienen como id:
  let motivoTexto = '';
  if (typeof this.motivoSeleccionado === 'number') {
    motivoTexto = this.motivos.find(m => m.idtema === this.motivoSeleccionado)?.tema || '';
  } else {
    motivoTexto = String(this.motivoSeleccionado);
  }

  let rangoTexto = '';
  if (typeof this.rangoSeleccionado === 'number') {
    rangoTexto = this.rangosHorarios.find(r => r.idtema === this.rangoSeleccionado)?.tema || '';
  } else {
    rangoTexto = String(this.rangoSeleccionado);
  }

  const instr = String(this.instruccionesEntrega || '').trim();
  const fechaYYYYMMDD = this.formatYYYYMMDD(this.selectedDate);

  this.rastreoService
    .reprogramarEntrega(rastreo, motivoTexto, instr, rangoTexto, fechaYYYYMMDD)
    .subscribe({
      next: (resp) => {

           // 📊 Evento GA4/GTM: entrega programada exitosamente
        this.analytics.event('entrega_programada', {
          motivoTexto,   // texto visible del motivo
          rastreo       // número de rastreo actual
        });

        Swal.fire({
          icon: 'success',
          title: resp?.Text || 'Operación exitosa',
          timer: 3000,
          timerProgressBar: true,
          showConfirmButton: false,
          customClass: { popup: 'swal-custom-font' }
        });
        this.cargarProgramacionEntregaActual();
        //  limpiar campos
        this.motivoSeleccionado = null;
        this.rangoSeleccionado = null;
        this.instruccionesEntrega = '';
        this.selectedDate = null;
      },
      error: (err) => {
        Swal.fire({
          icon: 'error',
          title: 'Error al programar',
          text: 'Intenta nuevamente más tarde.',
          timer: 2500,
          showConfirmButton: false
        });
        // console.error('Error reprogramarEntrega', err);
      }
    });
}

get puedeProgramar(): boolean {
  return Boolean(this.selectedDate && this.motivoSeleccionado && this.rangoSeleccionado);
}

private cargarProgramacionEntregaActual(): void {
  const rastreo = String(this.rastreoExpandido?.numrastreo || '').trim();
  if (!rastreo) {
    this.programacion = null;
    this.programacionFechaLegible = '';
    return;
  }

  this.rastreoService.obtenerProgramacion(rastreo).subscribe({
    next: (resp) => {
      // Normaliza: el backend podría regresar {}, [], null, o un objeto con campos vacíos
      const r = Array.isArray(resp) ? resp[0] : resp;

      const tieneDatos = !!(
        r &&
        (
          (r.fecha && String(r.fecha).trim()) ||
          (r.rango && String(r.rango).trim()) ||
          (r.motivo && String(r.motivo).trim()) ||
          (r.instrucciones && String(r.instrucciones).trim())
        )
      );

      this.programacion = tieneDatos ? r : null;
      this.programacionFechaLegible = tieneDatos && r?.fecha
        ? this.formatFechaLarga(r.fecha)
        : '';
    },
    error: () => {
      this.programacion = null;
      this.programacionFechaLegible = '';
    }
  });
}

// Utilidad para fecha “Martes 25 de julio”
private formatFechaLarga(yyyymmdd: string): string {
  if (!/^\d{8}$/.test(yyyymmdd)) return '';
  const y = +yyyymmdd.slice(0, 4);
  const m = +yyyymmdd.slice(4, 6) - 1; // 0-11
  const d = +yyyymmdd.slice(6, 8);
  const date = new Date(y, m, d);
  if (isNaN(date.getTime())) return '';

  const dias = ['domingo','lunes','martes','miércoles','jueves','viernes','sábado'];
  const meses = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];

  const dia = dias[date.getDay()];
  const mes = meses[m];
  // Capitaliza la primera letra del día
  return `${dia.charAt(0).toUpperCase()}${dia.slice(1)} ${d} de ${mes}`;
}

// Llama esto al entrar a la pestaña "Notificaciones" (y después de activar)
private cargarConfigNotificaciones(): void {
  if (!this.isLoguedin) { 
    this.notifs = []; 
    return; 
  }

  this.cargandoConfigNotif = true;
  const idcliente = this.idcliente;

  this.rastreoService.obtenerConfigNotificaciones(idcliente).subscribe({
    next: (resp: any) => {
      // el backend devuelve un arreglo
      this.notifs = Array.isArray(resp) ? resp : [];
    },
    error: () => {
      this.notifs = [];
    },
    complete: () => {
      this.cargandoConfigNotif = false;
    }
  });
}

eliminarNotificacion(n: any) {
  const idcliente = this.idcliente;

  Swal.fire({
    icon: 'warning',
    title: 'Eliminar notificación',
    html: `¿Deseas eliminar este medio de notificación <b>${n.tipo.toUpperCase()}</b> (${n.referencia})?`,
    showCancelButton: true,
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar',
    customClass: { popup: 'swal-custom-font' }
  }).then(res => {
    if (!res.isConfirmed) return;

    this.eliminandoNotifId = n.Idnotificacion;

    this.rastreoService.eliminarNotificacion(idcliente, n.Idnotificacion).subscribe({
      next: (resp: any) => {
        Swal.fire({
          icon: 'success',
          title: resp?.Text || 'Medio de notificación eliminado',
          timer: 2000,
          showConfirmButton: false,
          timerProgressBar: true,
          customClass: { popup: 'swal-custom-font' }
        });
        this.cargarConfigNotificaciones(); // refresca lista
      },
      error: () => {
        Swal.fire({
          icon: 'error',
          title: 'Error al eliminar',
          text: 'Inténtalo nuevamente.',
          customClass: { popup: 'swal-custom-font' }
        });
      },
      complete: () => {
        this.eliminandoNotifId = null;
      }
    });
  });
}

// Llamado cuando se va a mostrar la evidencia (o al colapsar tarjeta)
private hidratarEvidenciaDesdeRastreo(): void {
  const ent = this.rastreoExpandido?.entrega || null;
  this.entregaActual = ent;

  if (ent && String(ent.msgnum) === '1') {
    // Firma: si hay base64 válido, úsalo; si no, fallback
    const base64 = (ent.firmab64 || '').trim();
    if (base64 && base64 !== '-') {
      const dataUrl = `data:image/png;base64,${base64}`;
      this.firmaUrl = this.sanitizer.bypassSecurityTrustUrl(dataUrl);
    } else {
      this.firmaUrl = 'assets/iconos/firma_example.png';
    }

    // Fecha legible “Miércoles 22 de abril de 2025 08:21”
    this.fechaEntregaLegible = this.formateaFechaHoraEntrega(ent.fechamov, ent.horamov);
  } else {
    // Sin evidencia aún
    this.firmaUrl = 'assets/iconos/firma_example.png';
    this.fechaEntregaLegible = '';
  }
}


private formateaFechaHoraEntrega(fechadmy: string, hora: string): string {
  const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec((fechadmy || '').trim());
  if (!m) return `${fechadmy || ''} ${hora || ''}`.trim();

  const dd = +m[1], mm = +m[2] - 1, yyyy = +m[3];
  const d = new Date(yyyy, mm, dd);
  if (isNaN(d.getTime())) return `${fechadmy || ''} ${hora || ''}`.trim();

  const dias = ['domingo','lunes','martes','miércoles','jueves','viernes','sábado'];
  const meses = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
  const dia = dias[d.getDay()];
  const mes = meses[mm];

  return `${dia.charAt(0).toUpperCase()}${dia.slice(1)} ${dd} de ${mes} de ${yyyy} ${hora || ''}`.trim();
}

private isEntregado(r: any): boolean {
  if (!r) return false;
  const ult = Array.isArray(r.timeline) && r.timeline.length ? r.timeline[r.timeline.length - 1] : null;
  const ubicUlt = String(ult?.ubicacion || '').toUpperCase();
  const msgnum = Number(r?.entrega?.msgnum || 0);
  return ubicUlt === 'ENTREGA' || msgnum === 1;
}

private getMapaUrlParaRastreo(r: any): SafeResourceUrl {
  if (!r) return this.sanitizer.bypassSecurityTrustResourceUrl('');

  // Si ya fue entregado y hay coordenadas válidas, úsalas
  if (this.isEntregado(r)) {
    const lat = r?.entregaLat ?? (r?.entrega?.lat ? Number(r.entrega.lat) : NaN);
    const lng = r?.entregaLng ?? (r?.entrega?.lng ? Number(r.entrega.lng) : NaN);
    if (!isNaN(lat) && !isNaN(lng)) {
      // Con coords funciona bien con 'place' o 'search'
      const q = encodeURIComponent(`${lat},${lng}`);
      return this.sanitizer.bypassSecurityTrustResourceUrl(
        `https://www.google.com/maps/embed/v1/place?key=AIzaSyCyf5AM3wZYVE2fpG1Raus1Gbbuvdot79w&q=${q}`
        
      );
    }
  }

  // Fallback a tu última ubicación
  const ubicacion = this.getUltimaUbicacion(r);
  if (!ubicacion) return this.sanitizer.bypassSecurityTrustResourceUrl('');
  const q = encodeURIComponent(ubicacion.trim());
  return this.sanitizer.bypassSecurityTrustResourceUrl(
    `https://www.google.com/maps/embed/v1/place?key=AIzaSyCyf5AM3wZYVE2fpG1Raus1Gbbuvdot79w&q=${q}`
  );
}

private cargarPermisosEnvioActual(): void {
  const rastreo = String(this.rastreoExpandido?.numrastreo || '').trim();
  const idcliente = Number(this.idcliente ?? 0);

  if (!rastreo || !idcliente) {
    this.permisosEnvio = null;
    this.actualizarOpcionesVisibles();
    return;
  }

  this.rastreoService.getPermisosEnvio(rastreo, idcliente).subscribe({
    next: (resp: any) => {
      this.permisosEnvio = {
        CambiarDireccion: Number(resp?.CambiarDireccion ?? 0),
        CambiarHorario: Number(resp?.CambiarHorario ?? 0),
        PermitirAsistencias: Number(resp?.PermitirAsistencias ?? 0),
        PermitirIncidencias: Number(resp?.PermitirIncidencias ?? 0),
        Facturado: Number(resp?.Facturado ?? 0),
        Canje: String(resp?.Canje ?? ''),
        codigoCanje: String(resp?.Canje ?? ''),
        urlpdf: String(resp?.urlpdf ?? ''),
        urlxml: String(resp?.urlxml ?? ''),
        owner: String(resp?.owner ?? '').trim().toUpperCase(),
      };

      this.actualizarOpcionesVisibles();
    },
    error: () => {
      this.permisosEnvio = null;
      this.actualizarOpcionesVisibles();
    }
  });
}

descargarAmbos() {
  const pdf = this.permisosEnvio?.urlpdf;
  const xml = this.permisosEnvio?.urlxml;

  // 📊 Evento GA4/GTM: descarga de factura
  this.analytics.event('descargo_factura', {
    codigo: this.rastreoExpandido?.numrastreo || '(desconocido)',
    has_pdf: !!pdf,
    has_xml: !!xml
  });

  if (!pdf && !xml) return;

  if (pdf) window.open(pdf, '_blank', 'noopener');
  if (xml) window.open(xml, '_blank', 'noopener');
}

onSolicitarFacturaClick() {
  // 📊 Evento GA4/GTM: clic en “Solicitar Factura”
this.analytics.event('solicito_factura', {
  codigo: this.rastreoExpandido?.numrastreo || '(desconocido)'
});
}

get debeMostrarMapa(): boolean {
  // return;
  const ocultar = this.registrarIncidenciaActivo && this.validaEsIncidencia();
  return !ocultar && this.rastreoExpandido && !!this.mapaUrl;
}

success(key: string) {
  const c = this.filesFG.get(key);
  return !!this.fileNames[key] && !!c?.valid;
}

onChange(key: string, e: Event) {
  const input = e.target as HTMLInputElement;
  const file = input.files?.[0] || null;

  this.fileNames[key] = file ? file.name : '';

 this.selectedFiles[key] = file;     // ✅ guarda el File fuera del control
 const c = this.filesFG.get(key);
 c?.markAsDirty();
 c?.updateValueAndValidity();        // reevalúa el validador custom

  // (opcional) permitir volver a seleccionar el mismo archivo
  input.value = '';
}

onSubmitReclamo() {
  if (this.reclamacionForm.invalid) return;

  const v = this.reclamacionForm.value;
  const idusr = this.idcliente;
  const idinc = this.incidenciaDetalle?.idincidencia || 0; // usar el id que corresponda como idmensaje

  this.enviandorec = true;

  const guardaDatos$ = this.rastreoService.oprDatosReclamo(
    idinc, idusr, v.nombrerec, v.rfcrec, v.telrec, v.correorec,
    (v.contactorec || v.nombrerec), v.identrec, v.telcontactorec, v.correocontactorec
  );

  const uploads$ = this.buildAdjuntosRequests(idinc);

  forkJoin([guardaDatos$, ...uploads$]).subscribe({
    next: () => {
      this.enviandorec = false;
      Swal.fire({
        icon: 'success',
        title: 'Reclamo enviado',
        text: 'Datos y adjuntos registrados correctamente.',
        showConfirmButton: false,
        timer: 2200,
        timerProgressBar: true,
      });
    },
    error: () => {
      this.enviandorec = false;
      Swal.fire({
        icon: 'error',
        title: 'Error al enviar',
        text: 'Intenta nuevamente.',
        showConfirmButton: false,
        timer: 2500,
        timerProgressBar: true,
      });
    }
  });
}

////// CONTEO DE ADJUNTOS  //////////
private get filesFG(): FormGroup { return this.reclamacionForm.get('files') as FormGroup; }

get totalAdjuntosRequeridos(): number {
  return this.fields.length; // todos requeridos
}

get adjuntosCargados(): number {
  return this.fields.reduce((acc, f) => {
    const c = this.filesFG.get(f.key);
    // cuenta si tiene File (o valor precargado) y es válido
    return acc + (c && c.valid ? 1 : 0);
  }, 0);
}

get adjuntosRestantes(): number {
  return Math.max(this.totalAdjuntosRequeridos - this.adjuntosCargados, 0);
}
//////  TERMINA CONTEO DE ADJUNTOS  //////////

// Mapa de key -> tipo
private tipoPorKey: Record<string, 'CRT'|'REM'|'SEG'|'INE'|'FAC'> = {
  solicitud: 'CRT',
  remision_envio: 'REM',
  folio_seguro: 'SEG',
  ine: 'INE',
  factura: 'FAC',
};

// Convierte File a base64 (sin prefijo data:)
private fileToBase64(f: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => {
      const s = String(r.result || '');
      resolve(s.includes(',') ? s.split(',')[1] : s);
    };
    r.onerror = reject;
    r.readAsDataURL(f);
  });
}

// Crea un array de Observables de subida por cada archivo presente en el subform "files"
private buildAdjuntosRequests(idmensaje: number | string) {
  const filesFG = this.reclamacionForm.get('files');
  const requests = [];

  for (const f of this.fields) {
    const file: File | null = this.selectedFiles[f.key] ?? null;
    if (!file) continue;

    const tipo = this.tipoPorKey[f.key];
    const nombre = file.name;

    const req$ = from(this.fileToBase64(file)).pipe(
      mergeMap(b64 =>
        this.rastreoService.subirAdjuntoIncidencia('ALT', 0, idmensaje, tipo, nombre, b64)
      )
    );
    requests.push(req$);
  }
  return requests;
}

get adjuntosInc(): any[] {
  return this.incidenciaDetalle?.adjuntos?.filter(a => a?.tipo === 'INC') ?? [];
}

private setAdjuntosExistentesNoInc(adjuntos: Array<any> = []) {
  // limpia marcas anteriores
  Object.keys(this.filesFG.controls).forEach(k => {

    delete this.fileNames[k];
    this.selectedFiles[k] = null;
    this.existingFiles[k] = false;
  });

  // marca como cargados los que NO sean INC
  adjuntos
    .filter(a => a?.tipo && a.tipo !== 'INC')
    .forEach(a => {
      const key = this.tipoToKey[a.tipo];
      if (!key) return;

      // nombre mostrado en UI
      this.fileNames[key] = a?.nombrearchivo || 'Adjunto';

      // cualquier valor truthy hace válido el control (tienes Validators.required)
     this.existingFiles[key] = true;                                        // ✅
     const c = this.filesFG.get(key);
     c?.markAsTouched();
     c?.updateValueAndValidity({ emitEvent: false });
    });
}
get mensajesChat(): any[] {
  return (this.mensajesIncidencia || []).filter(m => (m?.mensaje || '').trim().length > 0);
}

}
